import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getPDPCustomizerURLParams, getSelectionsObj } from 'components/consumer/PDP/helpers/pdpQueryParamUtils';
import { isEmpty } from 'lodash';
const usePDPInitialOptionsFromQueryParams = t0 => {
  const $ = _c(5);
  const {
    productOptions,
    search
  } = t0;
  let t1;
  bb0: {
    if (!search) {
      t1 = null;
      break bb0;
    }
    let t2;
    if ($[0] !== search) {
      t2 = getPDPCustomizerURLParams({
        search
      });
      $[0] = search;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    t1 = t2;
  }
  const selectedOptionsUrlParams = t1;
  let t2;
  bb1: {
    if (!selectedOptionsUrlParams || !productOptions) {
      t2 = null;
      break bb1;
    }
    let t3;
    if ($[2] !== productOptions || $[3] !== selectedOptionsUrlParams) {
      const urlSelections = getSelectionsObj(productOptions, selectedOptionsUrlParams);
      t3 = !isEmpty(urlSelections) ? urlSelections : null;
      $[2] = productOptions;
      $[3] = selectedOptionsUrlParams;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = t3;
  }
  const selectedOptionsFromURLOverride = t2;
  return selectedOptionsFromURLOverride;
};
export default usePDPInitialOptionsFromQueryParams;